import { report } from "./checks.ts";
import type { RulesProblem } from "./types.ts";

/**
 * The check that reads the three XP rates against one another (ADR-083's amendment of 2026-10-07, A1): each rate's own
 * bounds are its record's (`MIN_XP_PERCENT` to `MAX_XP_PERCENT`), and this runs across the constants after their
 * records, reporting on the rate it refuses.
 */

/**
 * Checks the rates' order: Protected at most Flagged, and Flagged at most Hostile, so risk never earns less than
 * safety. A rate its own record refused is not compared.
 *
 * @param protectedRate The checked `xp_percent_protected`, or null when the constants hold none that passed.
 * @param flagged The checked `xp_percent_flagged`, or null likewise.
 * @param hostile The checked `xp_percent_hostile`, or null likewise.
 * @param problems Where problems go.
 */
export function checkXpRates(protectedRate: number | null, flagged: number | null, hostile: number | null, problems: RulesProblem[]): void {
  if (protectedRate !== null && flagged !== null && protectedRate > flagged) {
    report({ table: "constants", id: "xp_percent_protected", problems }, `count is ${protectedRate}, and it must be at most xp_percent_flagged, ${flagged}: risk never earns less than safety`);
  }
  if (flagged !== null && hostile !== null && flagged > hostile) {
    report({ table: "constants", id: "xp_percent_flagged", problems }, `count is ${flagged}, and it must be at most xp_percent_hostile, ${hostile}: risk never earns less than safety`);
  }
}
